import { handleRequest } from "../utilities/requestHandler";

export const getBanners = () => handleRequest("get", "/banners");

export const getActiveBanners = (legalEntity) =>
	handleRequest("get", "/banners/active", legalEntity ? { legalEntity } : null);

export const createBanner = (payload) => handleRequest("post", "/banners", payload);

export const updateBanner = (id, payload) => handleRequest("put", `/banners/${id}`, payload);

export const deleteBanner = (id) => handleRequest("delete", `/banners/${id}`);
